import { Link } from "react-router-dom";
import LegalPage, { Section, useCompany } from "@/components/public/LegalPage";

export default function Privacy() {
  const co = useCompany();
  return (
    <LegalPage title="Privacy Policy" testid="privacy-page">
      <p className="text-slate-600">
        This policy explains how {co.name} (company number {co.number}, registered office {co.office}) collects and uses your personal data. We are the data controller under UK GDPR and the Data Protection Act 2018.
      </p>
      <Section title="What we collect">
        <p>When you request a quote we collect your name, phone number, email address (optional), property address and postcode, the services you are interested in, your message and any photo you choose to upload.</p>
        <p>If you become a customer we also keep job, invoice and payment records.</p>
      </Section>
      <Section title="Why we use it (lawful basis)">
        <p>To respond to your quote request and take steps at your request before entering a contract (contract). To carry out and invoice work (contract). To keep accounting records (legal obligation). To protect our site from spam and misuse (legitimate interests).</p>
        <p>We do not sell your data or use it for marketing without your separate consent.</p>
      </Section>
      <Section title="Before & after photos">
        <p>We only publish photos of your property in our gallery with your permission, and never include personal details. You can ask us to remove a photo at any time.</p>
      </Section>
      <Section title="Who we share it with">
        <p>Our trusted service providers who host this website, its database and file storage, acting on our instructions. We may also share data where required by law (for example with HMRC).</p>
      </Section>
      <Section title="How long we keep it">
        <p>Quote enquiries that do not become work are deleted within 12 months. Customer and invoice records are kept for 6 years to meet UK tax requirements.</p>
      </Section>
      <Section title="Your rights">
        <p>You can ask to access, correct or delete your data, restrict or object to its use, or receive a copy. Contact us at {co.email} or {co.phone}. We will respond within one month.</p>
        <p>If you are unhappy, you can complain to the Information Commissioner's Office (ico.org.uk, 0303 123 1113).</p>
      </Section>
      <Section title="Cookies">
        <p>See our <Link to="/cookies" className="text-green-700 underline">Cookie Policy</Link>.</p>
      </Section>
    </LegalPage>
  );
}
